<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSurveyStore } from '@/stores/survey';
import SurveyActions from '@/components/survey/SurveyActions.vue';
import SurveyResponse from '@/components/survey/SurveyResponse.vue';
import SurveyProgress from '@/components/survey/SurveyProgress.vue';
import SurveyStep from '@/components/survey/SurveyStep.vue';
import PrimeLoader from '@/components/UI/PrimeLoader.vue';

const surveyStore = useSurveyStore();

const { questions, currentStep, totalSteps, isCompleted, showPreloader } =
	storeToRefs(surveyStore);

onMounted(() => {
	surveyStore.getQuestions();
});
</script>

<template>
	<main>
		<div v-if="showPreloader" class="app-preloader">
			<PrimeLoader size="64" color="primary-color" />
		</div>
		<template v-else>
			<div v-if="!isCompleted && totalSteps" class="survey">
				<SurveyProgress />
				<template v-for="(question, index) in questions" :key="question.id">
					<SurveyStep
						v-if="index + 1 === currentStep"
						:question-item="question"
						:index="index"
					/>
				</template>
				<div class="survey__actions">
					<SurveyActions />
				</div>
			</div>
			<SurveyResponse v-else />
		</template>
	</main>
</template>

<style lang="scss">
.app-preloader {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	flex: 1 0 auto;
	background-color: var(--white);
}

.survey {
	display: grid;
	grid-template-rows: auto 1fr;
	grid-template-columns: 100%;
	flex: 1 0 auto;
	padding-bottom: 6rem;

	&__actions {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		border-top: 1px solid var(--gray-100);
		width: 100%;
		background-color: var(--white);
	}
}
</style>
